module.exports = __webpack_public_path__ + "d1a42223b50e16ff4016367e20e33433.svg";